import type { ICellRendererParams } from 'ag-grid-community';
import type { AgGridWarningProps } from '../../AgGrid/types';
import { PMSRowWarnings } from '../../PMSRowWarnings';
import { BlotterAggFunc } from '../aggFuncs';
import type { ColDefFactory, Column } from './types';
import { warning } from './warning';
import type { WarningColumnValue } from './warning.types';

export interface PMSWarningColumnValue extends WarningColumnValue {
  warnings: string[];
}
function isPMSWarning(data: unknown): data is PMSWarningColumnValue {
  return (data as PMSWarningColumnValue)?.warnings != null;
}

/** The PMS grids provide a given list of warnings associated with severity - this aggregates these into a tooltip */
export const pmsWarnings: ColDefFactory<Column> = column => ({
  ...warning(column),
  cellRendererParams: (params: ICellRendererParams<unknown, WarningColumnValue | undefined>): AgGridWarningProps => {
    if (isPMSWarning(params.value)) {
      return {
        ...params,
        tooltip: <PMSRowWarnings warningData={params.value} />,
      };
    }

    return {
      ...params,
      value: undefined,
    };
  },
  initialAggFunc: column.initialAggFunc ?? (column.aggregate ? BlotterAggFunc.PmsWarning : undefined),
});
